import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import SitesMapPage from '@/routes/map/SitesMapPage'
import { RoleRoute } from '@/types'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { defer, LoaderFunction } from 'react-router-typesafe'

export const sitesMapPageRouteLoader = (async () => {
  return defer({
    title: 'Sedi',
  })
}) satisfies LoaderFunction

export const SitesMapPageRoute: RoleRoute = {
  path: 'sites-map',
  element: <SitesMapPage />,
  errorElement: <RouterErrorHandler />,
  loader: sitesMapPageRouteLoader,
  handle: {
    crumb: () => ({
      label: 'Sedi',
      icon: faMapMarkerAlt,
    }),
  },
  text: 'Sedi',
  faIcon: faMapMarkerAlt,
  mainMenuRoute: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Supervisor, Roles.Sales],
}
